module.exports = __webpack_public_path__ + "static/media/993832.3de2d2d5.png";